export enum commentTypes {
  MEDIA = 'Media',
  POST = 'Post',
  COMMENT = 'Comment',
}
